// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summary-card[data-v-6a771c68]{border-radius:var(--sds-b-radius-4);width:100%}.summary-card .summary-title[data-v-6a771c68]{color:var(--sds-purple-600)}.summary-card .summary-body[data-v-6a771c68]{gap:8px}.summary-card .summary-body .summary-line[data-v-6a771c68]{border-bottom:1px dashed #d8d8df}.summary-card .summary-footer[data-v-6a771c68]{bottom:0}", ""]);
// Exports
module.exports = exports;
